import script from "./CustomerExcelImport.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomerExcelImport.vue?vue&type=script&setup=true&lang=js"

import "./CustomerExcelImport.vue?vue&type=style&index=0&id=d6ec2bb0&scoped=true&lang=less"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d6ec2bb0"]])

export default __exports__